import * as HLF from "html-living-framework";
import { Application } from "../Application";
import {HoverableButton, TextureButton} from "../core/Button";
import { Container } from "../core/Container";
import {array, Callback, Mix} from "../core/Reflection";
import { Sprite } from "../core/Sprite";
import {TransformBackup} from "../core/TransformBackup";
import * as PlanterGameModel from "../data/PlanterGameModel";
import {TrashType} from "../data/TrashType";
import { OutlineFilter } from "../filters/OutlineFilter";
import { Button } from "./Button";
import { CustomizeOptionButton } from "./CustomizeOptionButton";

export class CustomizeTab extends Container {

    public set active(pValue: boolean) {
        this.bgOn.visible = pValue;
        this.bgOff.visible = !pValue;
        this.buttonsContainer.visible = pValue;
        this.buttonMode = !pValue;

        if (pValue) {
            this.enabled = true; // enables header
        }

        if (this.enabled) {
            this.interactive = !pValue; // disable tab header
            this.interactiveChildren = pValue; // enable tab content
            const filter = new OutlineFilter(5, 0xffff00);
            this.icon.filters = [filter];
        }

        if (pValue && !this._active) {
            // @ts-ignore
            this.hitArea = null;
            this._active = true;
            PubSub.publishSync("tab activated", this);
        }
        else if (!pValue && this._active) {
            this._active = false;
            this.hitArea = this._hitArea!;
        }

        if (this.enabled && !pValue) {
            this.icon.filters = [];
        }

    }

    public get active() {
        return this._active;
    }

    public set enabled(value: boolean) {
        if (value) {
            // this.interactive = true;
            if (this._active) {
                const filter = new OutlineFilter(5, 0xffff00);
                this.icon.filters = [filter];
            }
            else {
                this.icon.filters = [];
            }
        }
        else {
            // this.interactive = false;
            const filter = new PIXI.filters.ColorMatrixFilter();
            this.icon.filters = [filter];
            filter.desaturate();
        }
        this._enabled = value;
    }

    public get enabled() { return this._enabled; }
    public tabType: PlanterGameModel.Tabs;

    public readonly bgOff = this.addChild(new Sprite());
    public readonly bgOn = this.addChild(new Sprite());
    public readonly icon = this.addChild(new Sprite());
    public hitArea = new PIXI.Rectangle();
    public buttonsContainer = this.addChild(new PIXI.Container());
    public buttons = array((i) => this.buttonsContainer.addChild(new CustomizeOptionButton(this.tabType, i)));
    public visited: boolean = false;
    protected _enabled: boolean = true;

    protected _active: boolean = false;
    protected _subscriptions: any[] = [];
    private _hitArea?: PIXI.Rectangle;

    public constructor(pTabType: PlanterGameModel.Tabs) {
        super();
        this.tabType = pTabType;
    }

    public init(pActive: boolean) {
        this.on(HLF.Input.Events.POINTER_TAP, (e: PIXI.InteractionEvent) => {
            if (!this._enabled && !this._active) {
                HLF.Application.instance.audio.play("deadclick", 1, false, HLF.AudioCategory.SFX);
            }
            else if (this._enabled && !this._active) {
                PubSub.publishSync("tab clicked", this);
            }
        });
        this._subscriptions.push(PubSub.subscribe("tab clicked", this.onTabClicked.bind(this)));
        this._subscriptions.push(PubSub.subscribe("button clicked", this.onButtonClicked.bind(this)));
        this._hitArea = this.hitArea;
        // HLF.PixiUtils.setParent(this.buttonsContainer, this.parent); // HACK
        this.active = pActive;
        this.interactive = !pActive;
    }

    public destroy() {
        super.destroy();
        for (const subscription of this._subscriptions) {
            PubSub.unsubscribe(subscription);
        }
    }

    protected onTabClicked(pTopic: string, pData: CustomizeTab) {
        if (!this._enabled) { return; }
        if (pData === this) {
            this.active = true;
        }
        else {
            this.active = false;
        }
    }

    protected onButtonClicked(pTopic: string, pData: CustomizeOptionButton) {
        if (pData.tab === this.tabType) {
            this.visited = true;
        }
    }
}
